<template>
  <v-card outlined>
    <v-card flat>
      <v-card-title>Данные для приложения</v-card-title>

      <v-divider />

      <v-card-text>
        <v-textarea auto-grow label="Данные для входа" :value="authData" />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn text color="black" @click="copyAuthData()">Копировать</v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true }
  },

  computed: {
    authData() {
      return (
        `${this.user.surname} ${this.user.name} ${this.user.patronymic ||
          ""}, ${this.user.description || ""}` +
        "\n" +
        "\n" +
        `Для прохода через турникет доступны следующие опции:` +
        "\n" +
        `* смартфон с приложением "Кампус БГПУ"` +
        "\n" +
        "* банковская карта" +
        "\n" +
        "* идентификационная карта или брелок" +
        "\n" +
        "\n" +
        "Карту или брелок можно приобрести в центральном корпусе" +
        "\n" +
        "и привязать через терминал." +
        "\n" +
        "Привязать банковскую карту также можно через терминал." +
        "\n" +
        "\n" +
        `Приложение "Кампус БГПУ" доступно для скачивания:` +
        "\n" +
        "Google Play - play.google.com/store/apps/details?id=ru.bgpu.lk" +
        "\n" +
        "Huawei AppGallery - appgallery.huawei.com/app/C107210853" +
        "\n" +
        "также возможен доступ по адресу: " +
        "https://bgpu.ru/lk/" +
        "\n" +
        "Логин: " +
        `${this.user.login || ""}` +
        "\n" +
        "Пароль: " +
        `${this.user.password || "Пароль задан пользователем"}`
      );
    }
  },

  methods: {
    copyAuthData() {
      navigator.clipboard.writeText(this.authData);
    }
  }
};
</script>
